export const locationCodeJoinParams = ['createdBy||id,firstName,lastName']
